import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, computed } from 'vue';

interface Props {
  // ダイアログ表示フラグ
  isDispDialog: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ServiceTermDialog',
  props: {
    isDispDialog: { type: Boolean }
  },
  emits: ['closeDialog'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

// ダイアログ表示フラグ
const dialog = ref(computed(() => props.isDispDialog));

// スクロールフラグ
const isBottomScroll = ref(true);

/**
 * OKボタンを活性に設定
 * @param verticalPercentage 現在のスクロール位置
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const setEnableButton = ({ verticalPercentage }: any) => {
  // スクロール位置が最下部の場合
  if (verticalPercentage >= 0.8) {
    isBottomScroll.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_scroll_area = _resolveComponent("q-scroll-area")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    modelValue: dialog.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialog).value = $event)),
    persistent: "",
    class: "service-terms-area"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { style: {"width":"80%","max-width":"900px"} }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "text-center q-pb-none" }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createElementVNode("span", { class: "service-term-title" }, "サービス利用規約", -1)
            ])),
            _: 1
          }),
          _createVNode(_component_q_separator, {
            inset: "",
            spaced: ""
          }),
          _createVNode(_component_q_scroll_area, {
            style: {"height":"500px","width":"90%","margin":"0 auto","padding-right":"15px"},
            visible: "",
            onScroll: setEnableButton
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createElementVNode("p", null, "弊社サービスのご利用にあたりましては、以下の項目につきご同意頂くものといたします。", -1),
              _createElementVNode("div", { class: "service-term-item" }, "1. 提供製品の使用目的について", -1),
              _createElementVNode("p", null, " 在庫試薬・合成用試薬は、試験研究用途を目的として販売しています。バルク製品（電子材料、農薬原料、化粧品原料、塗料・インキ・接着剤、天然物、機能性材料、高分子材料、医薬品中間体、原薬（API）など）を、 高次の開発目的（治験薬の製造など）、商業製造などで使用する場合は、詳細について、弊社医薬品営業部あるいは化成品営業部（代表 03-6262-6467）にお問合せください。 ", -1),
              _createElementVNode("div", { class: "service-term-item" }, "2. 提供商品の保証期間について", -1),
              _createElementVNode("p", null, [
                _createTextVNode(" 製品の保証期間は、納入後6カ月以内といたします（別途定めがある場合を除きます）。"),
                _createElementVNode("br"),
                _createTextVNode(" 製品の品質には細心の注意を払っておりますが、万一不備等があり弊社が妥当と判断した場合、 当該製品の無償交換または製品代金の返却などの対応をいたします。"),
                _createElementVNode("br"),
                _createTextVNode(" ただし、製品の使用や保管に際して、お客様の故意又は過失などによる損害は、補償、責任を負いかねます。 ")
              ], -1),
              _createElementVNode("p", null, " また、試薬の純度については、スクリーニング化合物は90%以上、その他の製品は95%以上を想定しています。 ", -1),
              _createElementVNode("div", { class: "service-term-item" }, "3. 納期・供給不可品目(欠品)について", -1),
              _createElementVNode("p", null, [
                _createTextVNode(" 輸入作業、合成の遅れなどによる納期の遅れ、ご注文後の欠品、また合成の不成功などが生じるおそれがあります。"),
                _createElementVNode("br"),
                _createTextVNode(" また、上記欠品、合成の不成功等による仕入先サプライヤの切り替えなどにより、当初の見積金額からの変更が生じてしまう場合があります。なお、見積時に提示した納期からの大幅な遅れや欠品、見積金額の変更などが生じた場合は速やかにご連絡いたします。"),
                _createElementVNode("br"),
                _createTextVNode(" 納期管理には万全を期しますが、これらの原因により生じた損害につきましては、直接的な損害又は付随的・間接的な損害を問わず、一切の責任を負いかねます。 ")
              ], -1),
              _createElementVNode("div", { class: "service-term-item" }, "4. 化合物の立体表記について", -1),
              _createElementVNode("p", null, [
                _createTextVNode(" 弊社では、見積時に化合物の立体構造を表記する場合、仕入先のサプライヤから提供された情報のまま、記載しています。E体とZ体の区別や、R体とS体の区別、相対配置等については、構造描画上は確定されているように描かれていても、実際には「立体不明」や「混合物」などであるおそれがあります。また、ラセミ体とされているものであっても、一方の立体構造のみが含まれている場合もあります。"),
                _createElementVNode("br")
              ], -1),
              _createElementVNode("div", { class: "service-term-item" }, "5. 製品の保管について", -1),
              _createElementVNode("p", null, [
                _createTextVNode(" 弊社では、各サプライヤが作成したラベル又はSDSに記載された指示に従い、製品の保管や輸送などを行っております。"),
                _createElementVNode("br")
              ], -1),
              _createElementVNode("div", { class: "service-term-item" }, "6. 発注後のキャンセルについて", -1),
              _createElementVNode("p", null, " 弊社への発注後の、お客様のご都合によるキャンセルはお受けすることができません（別途定めがある場合を除きます）。 ", -1),
              _createElementVNode("p", null, "本サービス利用規約は予告なしに変更または中止されることがあります。", -1),
              _createElementVNode("div", { class: "service-term-item" }, "特許権侵害物質排除ポリシー", -1),
              _createElementVNode("p", null, " 弊社では、試験研究用途の場合、弊社製品による第三者の特許権の有無およびその侵害について、調査を行っておりません。 ", -1)
            ])),
            _: 1
          }),
          _createVNode(_component_q_card_actions, {
            align: "center",
            class: "q-mt-sm q-mb-md"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_btn, {
                color: "primary",
                label: "OK",
                disable: isBottomScroll.value,
                style: {"width":"220px"},
                onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('closeDialog', true)))
              }, null, 8, ["disable"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})